"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _collapse = require("./collapse.styles");

var _jsxRuntime = require("react/jsx-runtime");

const CollapseIcon = ({ ...props
}) => {
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_collapse.StyledCollapseIcon, {
    role: "presentation",
    focusable: "false",
    className: "nextui-collapse-icon",
    width: "20",
    height: "20",
    fill: "none",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      d: "M15.5 19l-7-7 7-7",
      strokeWidth: 1.5,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    })
  });
};

CollapseIcon.toString = () => '.nextui-collapse-icon';

const MemoCollapseIcon = /*#__PURE__*/_react.default.memo(CollapseIcon);

var _default = MemoCollapseIcon;
exports.default = _default;
module.exports = exports.default;